import i18n from "@biuwer/core/src/i18n";

import { addNotification } from "@biuwer/redux/src/system/notifications/notifications-actions";

function removeChild(child) {
    document.body.removeChild(child)
};

function fallbackCopryToClipboard(text) {
    let textArea = document.createElement("textarea")
    textArea.value = text
    textArea.style.position = "fixed"  //avoid scrolling to bottom
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    try {
        document.execCommand('copy')
        removeChild(textArea)
    } catch (err) {
        removeChild(textArea)
        throw err
    }
}

/**
 * Copy given text to clipboard
 * @param {string} text text to copy to clipboard
 * @returns {Promise<boolean>}
 */
export async function copyToClipboard(text) {
    try {
        if (!navigator.clipboard) {
            fallbackCopryToClipboard(text)
        } else {
            await navigator.clipboard.writeText(text)
        }

        return true
    } catch (err) {
        throw err
    }
}

/**
 * Copy given text to clipboard and launches a notification
 * @param text, text to copy to clipboard
 * @param i18nConfig, i18n options. Default options show the available params
 * @returns {function(*)}
 */
export default function copyToClipboardAction(text, i18nConfig = { name: i18n.t('authTokens.title'), context: 'male', count: 1 }) {
    return async dispatch => {
        try {
            await copyToClipboard(text)

            return dispatch(addNotification({
                styleType: 'success',
                message: i18n.t('notifications.copyToClipboardSuccess', i18nConfig)
            }))
        } catch (err) {
            return dispatch(addNotification({
                styleType: 'error',
                message: i18n.t('notifications.error')
            }))
        }
    }
}
